var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [
                _vm._v(_vm._s(_vm.$ct("sale-requirements"))),
              ]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-radio", {
                            attrs: {
                              label: _vm.$ct("requirements-hide"),
                              name: _vm.radioName,
                              checked: _vm.hiddenChecked,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setHidden()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-radio", {
                            attrs: {
                              label: _vm.$ct("requirements-after-totals"),
                              name: _vm.radioName,
                              checked: _vm.afterTotalsChecked,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setAfterTotals()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-radio", {
                            attrs: {
                              label: _vm.$ct("requirements-on-new-page"),
                              name: _vm.radioName,
                              checked: _vm.newPageChecked,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setOnNewPage()
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: {
                              label: _vm.$ct(
                                "requirements-add-background-image"
                              ),
                              value:
                                !_vm.requirements
                                  .DontPrintBackgroundImageOnRequirements,
                              disabled: !_vm.newPageChecked,
                            },
                            on: {
                              input: function ($event) {
                                _vm.requirements.DontPrintBackgroundImageOnRequirements =
                                  !$event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-link",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.editStyle = true
                                },
                              },
                            },
                            [
                              _c("w-fa", { attrs: { icon: "font" } }),
                              _vm._v(
                                _vm._s(_vm.$ct("edit-requirements-style")) + " "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.editStyle } },
        [
          _c("app-style-editor", {
            on: {
              close: function ($event) {
                _vm.editStyle = false
              },
            },
            model: {
              value: _vm.requirements.Style,
              callback: function ($$v) {
                _vm.$set(_vm.requirements, "Style", $$v)
              },
              expression: "requirements.Style",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }